import { memo, useMemo } from 'react';
import { View, StyleSheet, Text, Pressable } from 'react-native';
import { Panel, DateUtils, DatePicker, Image, Utils } from '../../components';
import { THEME, __WEB__, COLOR, FONT } from '../../../constants/styles';
import { connect } from 'react-redux';
import { getCasesForEmployerInCurrentUsersGroup } from '../../../selectors/employers';
import { currentDeploymentInfoForPatient, currentPHAInfoForPatient } from '../helpers';

const DATE_COL_W = __WEB__ ? 230 : 130;
const DOT_COL_W = __WEB__ ? 100 : 70;

function renderReadinessOrPHARow(c, onTap, onSaveDue) {
  const dateStr = c.date ? DateUtils.formatDateStringNumeric(c.date) : '';
  const dueDate = c.date ? new Date(c.date) : null;
  function handleResidentTap() {
    onTap(c.caseId);
  }
  function handleDateSave(dueDate) {
    onSaveDue?.(c.caseId, dueDate);
  }

  return (
    <View style={THEME.basicRow} key={`${c.caseId}`}>
      <View style={[THEME.rowColumn, { width: DATE_COL_W, paddingRight: 25 }]}>
        <DatePicker
          placeholder="DUE DATE"
          validateFunc={Utils.validate.date}
          invalidText={'Please enter a valid date'}
          required={false}
          mode="date"
          webModal={true}
          onDate={handleDateSave}
          selectedDate={dueDate}
          calendarIcon={
            <Image
              style={styles.calImage}
              source={require('../../../../resources/nav-icon-calendar.png')}
            />
          }
          className="react-date-picker-part-a"
        />
      </View>
      {/*<Pressable style={[THEME.rowColumn, { width: DATE_COL_W }]} onPress={handleDueDateTap}>
        <Text style={THEME.rowText}>{dateStr || 'Not Due'}</Text>
      </Pressable>*/}
      <View style={[THEME.rowColumn, { flex: 1, justiafyContent: 'flex-end', marginTop: 10 }]}>
        <Pressable style={styles.nameButton} onPress={handleResidentTap}>
          <Text style={styles.linkStyle} numberOfLines={1} ellipsizeMode="tail">
            {c.name}
          </Text>
        </Pressable>
      </View>
      <View style={[THEME.rowColumn, { width: DOT_COL_W, paddingLeft: 20 }]}>
        <View style={[styles.deployDot, { backgroundColor: c.readyBG }]} />
      </View>
    </View>
  );
}

function filterAndSort(caseInfos) {
  return caseInfos
    .filter((c) => c !== null)
    .sort(function (a, b) {
      if (a.date > b.date) {
        return 1;
      } else if (a.date < b.date) {
        return -1;
      } else {
        if (b.name > a.name) return -1;
        else return 1;
      }
    });
}
function sortedReadinessCases(cases) {
  return filterAndSort(
    cases.map((c) => {
      const info = currentDeploymentInfoForPatient(c?.patient);
      if (!info?.date) return null;

      const ready = !!info?.ready?.clearanceGranted;
      const readyBG = ready ? COLOR.success : COLOR.warn;
      return {
        ...c,
        date: info.date,
        name: c.name,
        readyBG,
      };
    })
  );
}
function sortedPHACases(cases) {
  return filterAndSort(
    cases.map((c) => {
      const info = currentPHAInfoForPatient(c?.patient);
      // if (!info?.dueDate) return null;

      const ready = !!info?.approvedDate;
      const readyBG = ready ? COLOR.success : info.isPast ? COLOR.redOrangeColor : COLOR.warn;

      return {
        ...c,
        date: info.dueDate,
        name: c.name,
        readyBG,
      };
    })
  );
}
const PHASummary = memo(
  connect(function (state, ownProps) {
    const cases = getCasesForEmployerInCurrentUsersGroup(state);
    const phaCases = cases?.length ? sortedPHACases(cases) : [];
    return {
      phaCases,
    };
  }, null)(function (props) {
    function renderRow(c) {
      return renderReadinessOrPHARow(c, props.handleResidentTap, props.handlePHADueSave);
    }
    return (
      <Panel title={'Squadron Upcoming PHA Status'}>
        <View>
          <View style={THEME.sectionHeader}>
            <View style={[THEME.sectionHeaderColumn, { width: DATE_COL_W }]}>
              <Text style={THEME.sectionHeaderText}>DUE DATE</Text>
            </View>
            <View style={[THEME.sectionHeaderColumn, { flex: 1 }]}>
              <Text style={THEME.sectionHeaderText}>AIRMAN</Text>
            </View>
            <View style={[THEME.sectionHeaderColumn, { width: DOT_COL_W, borderRightWidth: 0 }]}>
              <Text style={THEME.sectionHeaderText}>STATUS</Text>
            </View>
          </View>
          <View>{props.phaCases?.map(renderRow)}</View>
        </View>
      </Panel>
    );
  })
);

const ReadinessSummary = memo(
  connect(function (state, ownProps) {
    const cases = getCasesForEmployerInCurrentUsersGroup(state);
    const readinessCases = cases?.length ? sortedReadinessCases(cases) : [];
    return {
      readinessCases,
    };
  }, null)(function (props) {
    function renderRow(c) {
      return renderReadinessOrPHARow(c, props.handleResidentTap);
    }
    return (
      <Panel title={'Squadron Upcoming Readiness Status'}>
        <View>
          <View style={THEME.sectionHeader}>
            <View style={[THEME.sectionHeaderColumn, { width: DATE_COL_W }]}>
              <Text style={THEME.sectionHeaderText}>READINESS DATE</Text>
            </View>
            <View style={[THEME.sectionHeaderColumn, { flex: 1 }]}>
              <Text style={THEME.sectionHeaderText}>NAME</Text>
            </View>
            <View style={[THEME.sectionHeaderColumn, { width: DOT_COL_W, borderRightWidth: 0 }]}>
              <Text style={THEME.sectionHeaderText}>STATUS</Text>
            </View>
          </View>
          <View>{props.readinessCases?.map(renderRow)}</View>
        </View>
      </Panel>
    );
  })
);

const styles = StyleSheet.create({
  deployDot: {
    width: 20,
    height: 20,
    borderRadius: 10,
  },
  nameButton: {},
  linkStyle: {
    ...THEME.textMedium,
    ...THEME.linkStyle,
  },
});

module.exports = {
  PHASummary,
  ReadinessSummary,
};
